import { observer } from "mobx-react-lite";
import type React from "react";
import type { PropsWithChildren } from "react";
import { View, XStack } from "tamagui";
import { PrimaryCheckText } from "../../../core/components/PrimaryCheck";
import { Block, type BlockProps } from "../../../ui/Block";
import type { InfoRowItemProps } from "../../../ui/InfoRow";
import { Label } from "../../../ui/Label";
import type BusinessModuleModel from "../BusinessModuleModel";
import { BusinessModuleIcon } from "./BusinessModuleIcon";

export const BusinessModuleBlock: React.FC<
  PropsWithChildren<
    {
      // biome-ignore lint/suspicious/noExplicitAny: Because
      businessModule: BusinessModuleModel<any, any>;
      infoRowItems?: InfoRowItemProps[];
      doneText?: string;
    } & BlockProps
  >
> = observer(
  ({ businessModule, infoRowItems, doneText, children, ...blockProps }) => {
    const isDone = businessModule.isCompletedByUserOrTeam;

    return (
      <Block
        grouped
        infoRowItems={infoRowItems}
        icon={
          <View position="relative">
            <BusinessModuleIcon
              key={`${businessModule.data.emoji}`}
              businessModule={businessModule}
            />
          </View>
        }
        {...blockProps}
      >
        <XStack gap="$medium" flex={1} justifyContent={"space-between"}>
          <View flex={1}>
            <Label alignSelf="flex-start">
              {businessModule.data.title
                ? businessModule.data.title
                : "Set title..."}
            </Label>
            {isDone && doneText ? (
              <PrimaryCheckText text={doneText} />
            ) : undefined}
            {children}
          </View>
        </XStack>
      </Block>
    );
  },
);
